import { useEffect, useRef } from 'react';
import { socket } from '../lib/socket';

export function useSocketEvent<T>(event: string, handler: (data: T) => void) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    function listener(data: T) {
      handlerRef.current(data);
    }
    socket.on(event, listener);
    return () => {
      socket.off(event, listener);
    };
  }, [event]);
}
